import { useMutation, useQueryClient } from '@tanstack/vue-query';

import { grantUserSupportAccessToAccount } from '../api/me';
import { keys } from '../keys';

export const useGrantUserSupportAccessToAccount = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: grantUserSupportAccessToAccount,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: keys.accounts.supportGranted._def });
    },
  });
};
